<div class="title"><span>{{qrData.text}}</span></div>
<qrcode [qrdata]="qrData.data" [width]="285" cssClass="qr-code-container" [errorCorrectionLevel]="'M'"></qrcode>

